exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icon-gwa {\n    width: 24px;\n    height: 24px;\n}\n\n.icon-gwa:hover {\n    opacity: .8\n}\n\n.icon-gwa:hover #camera{\n    fill: #542376!important;\n}\n\nsvg#icon-video {\n    border: solid 1px;\n}\n\nbutton.button_with-icon {\n    border: 0;\n}\n\n.icon-videocam {\n    display: block;\n    color: rgba(0, 0, 0, 0.87);\n    fill: rgb(117, 117, 117);\n    height: 24px;\n    width: 24px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    -o-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    position: absolute;\n    top: 4px;\n    margin: 12px;\n    left: 8px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/icon/icon.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/icon/icon.css
// module chunks = 0